export const TAG_COLORS = {
  SUCCESS: "green",
  WARNING: "orange",
  ERROR: "volcano",
  INFO: "cyan",
  METADATA: "gold",
  DANGER: "red",
  PENDING: "purple",
  UNKNOWN: "magenta",
} as const;

export const STATUS_COLORS: Record<string, string> = {
  // Generic
  active: TAG_COLORS.SUCCESS,
  inactive: TAG_COLORS.WARNING,

  // Job/Process
  completed: TAG_COLORS.SUCCESS,
  processing: TAG_COLORS.INFO,
  started: TAG_COLORS.INFO,
  failed: TAG_COLORS.ERROR,
  bounced: TAG_COLORS.ERROR,
  sent: TAG_COLORS.SUCCESS,

  // Order
  draft: TAG_COLORS.INFO,
  valid: TAG_COLORS.INFO,
  invalid: TAG_COLORS.WARNING,
  pending: TAG_COLORS.PENDING,
  fulfilled: TAG_COLORS.SUCCESS,
  rolled_back: TAG_COLORS.WARNING,

  // Order upload processing
  uploaded: TAG_COLORS.INFO,
  validating: TAG_COLORS.INFO,
  submitting_to_ukho: TAG_COLORS.INFO,
  issuing_permits: TAG_COLORS.INFO,
  validation_failed: TAG_COLORS.ERROR,
  ukho_errors: TAG_COLORS.WARNING,
};

export const getBooleanTagColor = (value: boolean): string =>
  value ? TAG_COLORS.SUCCESS : TAG_COLORS.WARNING;

export const getStatusTagColor = (status: string): string =>
  STATUS_COLORS[status.toLowerCase()] || TAG_COLORS.UNKNOWN;

export const getVerificationStatusColor = (status: string): string => {
  switch (status) {
    case "approved":     return TAG_COLORS.SUCCESS;
    case "not_approved": return TAG_COLORS.DANGER;
    case "pending":      return TAG_COLORS.WARNING;
    default:             return TAG_COLORS.UNKNOWN;
  }
};
